/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { CustomerProfileLocationDtoModel, CustomerProfileLocationDtoModelType } from "./CustomerProfileLocationDtoModel"
import { CustomerProfileLocationDtoModelSelector } from "./CustomerProfileLocationDtoModel.base"
import { CustomerProfileTimeWindowDtoModel, CustomerProfileTimeWindowDtoModelType } from "./CustomerProfileTimeWindowDtoModel"
import { CustomerProfileTimeWindowDtoModelSelector } from "./CustomerProfileTimeWindowDtoModel.base"
import { RootStoreType } from "./index"


/**
 * CustomerProfileDtoBase
 * auto generated base class for the model CustomerProfileDtoModel.
 */
export const CustomerProfileDtoModelBase = ModelBase
  .named('CustomerProfileDto')
  .props({
    __typename: types.optional(types.literal("CustomerProfileDto"), "CustomerProfileDto"),
    id: types.identifier,
    /** Whether the saved customer profile has been soft deleted */
    deleted: types.union(types.undefined, types.boolean),
    name: types.union(types.undefined, types.null, types.string),
    email: types.union(types.undefined, types.null, types.string),
    phone: types.union(types.undefined, types.null, types.string),
    /** Special instructions or notes */
    notes: types.union(types.undefined, types.null, types.string),
    /** Notes2 (V2 legacy); used by search, read-only in V3 */
    notes2: types.union(types.undefined, types.null, types.string),
    location: types.union(types.undefined, types.null, types.late((): any => CustomerProfileLocationDtoModel)),
    /** Service duration in seconds */
    duration: types.union(types.undefined, types.null, types.number),
    /** Whether this is a priority customer */
    isPriority: types.union(types.undefined, types.null, types.boolean),
    /** Load/capacity units */
    load: types.union(types.undefined, types.null, types.number),
    timeWindows: types.union(types.undefined, types.null, types.array(types.late((): any => CustomerProfileTimeWindowDtoModel))),
    createdDate: types.union(types.undefined, types.null, types.string),
    updatedDate: types.union(types.undefined, types.null, types.string),
    /** Custom fields/metadata as key-value pairs */
    metadata: types.union(types.undefined, types.null, types.frozen()),
    /** Customer type tags */
    tags: types.union(types.undefined, types.null, types.array(types.string)),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class CustomerProfileDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get deleted() { return this.__attr(`deleted`) }
  get name() { return this.__attr(`name`) }
  get email() { return this.__attr(`email`) }
  get phone() { return this.__attr(`phone`) }
  get notes() { return this.__attr(`notes`) }
  get notes2() { return this.__attr(`notes2`) }
  get duration() { return this.__attr(`duration`) }
  get isPriority() { return this.__attr(`isPriority`) }
  get load() { return this.__attr(`load`) }
  get createdDate() { return this.__attr(`createdDate`) }
  get updatedDate() { return this.__attr(`updatedDate`) }
  get metadata() { return this.__attr(`metadata`) }
  get tags() { return this.__attr(`tags`) }
  location(builder: string | CustomerProfileLocationDtoModelSelector | ((selector: CustomerProfileLocationDtoModelSelector) => CustomerProfileLocationDtoModelSelector) | undefined) { return this.__child(`location`, CustomerProfileLocationDtoModelSelector, builder) }
  timeWindows(builder: string | CustomerProfileTimeWindowDtoModelSelector | ((selector: CustomerProfileTimeWindowDtoModelSelector) => CustomerProfileTimeWindowDtoModelSelector) | undefined) { return this.__child(`timeWindows`, CustomerProfileTimeWindowDtoModelSelector, builder) }
}
export function selectFromCustomerProfileDto() {
  return new CustomerProfileDtoModelSelector()
}

export const customerProfileDtoModelPrimitives = selectFromCustomerProfileDto().deleted.name.email.phone.notes.notes2.duration.isPriority.load.createdDate.updatedDate.metadata.tags
